export default __webpack_public_path__ + "static/media/gym-and-fitness-icon.f14572f6.svg";